<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-lg-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-calendar
          date-picker.form-control-sm(v-model="workingDate" :config="locale" @input="getBankStatementDaily()")
      .form-group.col-md-5.col-lg-5
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $tc("ui.banks", 1) }}
          BankAccountList(
            ref="bank"
            size="sm"
            required
            type="array"
            v-model="bank"
            :disabled="loading"
            filterBankAccStatus=false
            all=true
            :operatorID="operatorID"
            @input="getBankStatementDaily()"
          )
      .form-group.col-md-12.col-lg-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getBankStatementDaily()"
          variant="primary"
          size="sm"
        ).mr-2
        //- jsonToExcel(v-if="reportList.length > 0" mode="BankStatementDaily" tbl="tblList" :date="dateRange")
  .card-body
    .row
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%")
                  span(:title="$tc('ui.banks',1)") {{ $tc('ui.banks',1) }}
                th(width="20%")
                  span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
                th.text-right(width="15%")
                  span(:title="$t('ui.deposit')") {{ $t('ui.deposit') }}
                th.text-right(width="15%")
                  span(:title="$t('ui.withdrawal')") {{ $t('ui.withdrawal') }}
                th.text-right(width="15%")
                  span(:title="$t('ui.total')") {{ $t('ui.total') }}
            tbody.clusterize-content
              tr(v-if="reportList.length == 0")
                td(:colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in reportList")
                td.text-center
                  span {{ index + 1 }}
                td
                  span(:title="item.bank_id") {{ item.bank_id }}
                td
                  span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                td.text-right
                  span(:title="$n(item.deposit, 'currency')") {{ $n(item.deposit, 'currency') }}
                td.text-right
                  span(:title="$n(item.withdrawal, 'currency')") {{ $n(item.withdrawal, 'currency') }}
                td.text-right
                  span(:title="$n(item.total, 'currency')" :class="$helpers.fontClassName(item.total)") {{ $n(item.total, 'currency') }}
              tr(v-if="showTotal")
                td.text-right(colspan="3")
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDeposit)" :title="$n(grandTotalDeposit, 'currency')") {{ $n(grandTotalDeposit, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawal)" :title="$n(grandTotalWithdrawal, 'currency')") {{ $n(grandTotalWithdrawal, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTotal)" :title="$n(grandTotalTotal, 'currency')") {{ $n(grandTotalTotal, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import BankAccountList from "@/library/BankAccountList";
import jsonToExcel from "@/library/jsonToExcel.vue";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  components: {
    SubmitButton,
    BankAccountList,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    reportList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    startDate: null,
    endDate: null,
    bank: '',
    currentBank: null,
    workingDate: null,
    sortKey: "transfer_date",
    sortType: "desc",
    grandTotalDeposit: 0,
    grandTotalWithdrawal: 0,
    grandTotalTotal: 0,
    showTotal: false,
    dateRange: {
      startDate: null,
      endDate: null
    },
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  methods: {
    refresh() {
      this.workingDate = this.$moment(new Date).format('YYYY-MM-DD');
    },
    getBankStatementDaily: function() {
      this.currentBank = this.bank;
      this.dateRange.startDate = this.workingDate;
      this.dateRange.endDate = this.workingDate;

      let url = config.bankStatementDailyUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        working_date: this.workingDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.statement.length > 0) {
                  this.showTotal = true;

                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalDeposit = response.data.ds.grand_total[0]["deposit"];
                    this.grandTotalWithdrawal = response.data.ds.grand_total[0]["withdrawal"];
                    this.grandTotalTotal = response.data.ds.grand_total[0]["total"];
                  }

                  this.reportList = response.data.ds.statement;
                } else {
                  this.clearTotal()
                }
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.reportList = []
      this.grandTotalDeposit = 0
      this.grandTotalWithdrawal = 0
      this.grandTotalTotal = 0
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>